// extracted by mini-css-extract-plugin
export default {"JoinTeam":"JoinTeamModal_JoinTeam__hsg5M","editNameContent":"JoinTeamModal_editNameContent__VWRqY"};